import * as React from 'react'
import {
  HeaderContainer,
  HeaderContent,
  HeaderTitle,
  HeaderTitleTop, ImageContainer,
  Quote, MissionMessageText, StyledImage, Sign, MissionMessageContainer, StyledDiv, MissionMessageFirst
} from './MissionMessage.elements'

type MissionMessageProps = {
  type: string
  text: string
  title: string
  topTitle: string
  first: boolean
  center: boolean
  imageUrl: string
}

type Props = {
  data: MissionMessageProps[]
}

export const MissionMessage: React.FunctionComponent<Props> = ({data}) => {

  return (
    <MissionMessageContainer>
      {
        data.map((e, idx) => {
          if(e.type === "Header"){
            return (
              <HeaderContainer key={e.type + idx}>
                <HeaderContent>
                  <HeaderTitleTop dangerouslySetInnerHTML={{ __html: e.topTitle }} />
                  <HeaderTitle dangerouslySetInnerHTML={{ __html: e.title }} />
                </HeaderContent>
              </HeaderContainer>
            )
          } else if (e.type === "Text"){
            return (
              e.first ?
                <MissionMessageFirst center={e.center} key={e.type + idx} dangerouslySetInnerHTML={{ __html: e.text }} />
                : <MissionMessageText center={e.center} key={e.type + idx} dangerouslySetInnerHTML={{ __html: e.text }} />
              )
          } else if (e.type === "Image"){
            return (
              <ImageContainer key={e.type + idx}>
                <StyledImage src={e.imageUrl}/>
              </ImageContainer>
            )
          } else if (e.type === "Quote"){
            return <Quote key={e.type + idx} dangerouslySetInnerHTML={{ __html: e.text }} />
          } else if (e.type === "Signature"){
            return (
              <StyledDiv key={e.type + idx}>
                <Sign dangerouslySetInnerHTML={{ __html: e.text }} />
              </StyledDiv>
            )
          }
        })
      }
    </MissionMessageContainer>
  )
}
